import Chosen from './chosen/chosen';
import Extend from './utils/extend';

export default class MagicPicker {

  constructor() {
    this.magicPickerDiv = document.querySelector('.magic-picker');

    if ( this.magicPickerDiv ) {
      const dataEl = this.magicPickerDiv.querySelector("script[magic-picker-data]");
      if ( !dataEl ) {
        return;
      }

      try {
        let data = JSON.parse(dataEl.innerHTML);
        const { formId, fields = {} } = data;

        const form = this.getById(formId) ||
        // trying the ID with a prefix because it's sometimes
        // added by Symfony // Piotr
        this.getById('form_'+formId) ||
        // trying the default ID because it might have been overwritten,
        // hopefully we can remove this in future // Piotr
        this.getById('appForm');

        if ( !form ) {
          throw new TypeError('[magic-pickers] Form not found.');
        }

        Object.keys(fields).forEach(
          (fieldId) => this.initField(form, fieldId, fields[fieldId].options || {}, fields)
        );

        // Hide headers without visible fields.
        form.querySelectorAll('h3').forEach((heading) => {
          let hide = true;
          let next = heading;
          while ((next = next.nextElementSibling) && next.classList.contains('form-group')) {
            if (!next.classList.contains('d-none')) {
              hide = false;
              break;
            }
          }
          if (hide) {
            heading.classList.add('d-none');
          }
        });

      } catch (err) {
        if ( err instanceof SyntaxError ) {
          console.error("[magic-picker-data] Can not parse data.", dataEl.innerHTML);
        } else {
          console.error(err)
        }
        throw err;
      }
    }
  }

    /**
   * Initialize magic picker field by fieldOptions.
   *
   *     this.initField(form, fieldId, fieldOptions);
   *
   * @param {HTMLElement} form
   * @param {String} fieldId
   * @param {Object} fieldOptions
   * @param {Object} fields
   * @return {void}
   */
    initField(form, fieldId, fieldOptions, fields) {
      const self = this;
      const field = this.getById(fieldId);

        if (!field) {
          return;
        }

      if (fieldOptions.hide) {
        this.setParentElementVisibility(field);
      } else {
        this.setParentElementVisibility(field, true);
      }

    if (fieldOptions.preload) {
      this.preloadValue(field, fieldOptions.picker_name);
    }

      if (fieldOptions.dependant_on) {
        fieldOptions.dependant_on.forEach((elementId, index, array) => {
          // For some reason addEventListener for change event doesn't work..
          // This is small workaround.
          // TODO find way to use pure JS instead of jQuery event handler.
          // onchange event doesn't allow to attach two events at the same time.
          const $select = $(self.getById(elementId));
          $select.on('change', evt => {
            if (evt.target.nodeName.toLowerCase() === 'select') {
              const selectedOption = evt.target.options[evt.target.selectedIndex];
              if (this.value === 'add' && selectedOption.dataset.url) {
                window.location = selectedOption.dataset.url;
                return;
              }
            }
            self.pickerVisibility(
              array,
              field,
              form,
              fieldOptions,
              fields
            );
          });
          if($select.val()) {
            const event = document.createEvent('Event');
            event.initEvent("change", true, false);
            $select[0].dispatchEvent(event);
          }
        });
      }

      if (fieldOptions.picker) {
        if (!fieldOptions.dependant_on || !fieldOptions.dependant_on.length) {
          this.preparePicker(form, field, fieldOptions.picker_name, fieldOptions.include_values, {}, fieldOptions.is_multiple);
        } else {
          const picker = this.createPicker(field, fieldOptions.is_multiple);
          field.parentElement.insertBefore(picker, field);
          field.newField = picker;
          const chosenClass = new Chosen();
          chosenClass.initializeChosen($(picker));
          $(picker).next().addClass('chosen-container-img');
        }
      }
    }

  /**
   * Hide parent element with .form-group class.
   *
   *     hideParentElement(field);
   *
   * @param {HTMLElement} field
   * @param {Boolean} visible
   * @return {void}
   */
    setParentElementVisibility(field, visible = false) {
      var parent = field.parentElement;
      if (parent && parent.classList.contains('form-group')) {
        (visible ? parent.classList.remove('d-none') : parent.classList.add('d-none'));
      }
    }

    /**
     * Check if field has value.
     *
     *     this.hasValue(field);
     *
     * @param {HTMLElement} field
     * @return {Boolean} If field has value.
     */
    hasValue(field) {
      return !!field.value;
    }

    /**
     * Change element value on GET call response.
     *
     *     this.preloadValue(field, pickerName);
     *
     * @param {HTMLElement} field
     * @param {String} pickerName
     * @return {void}
     */
    preloadValue(field, pickerName) {
      $.get(this.getPickerPathByName(pickerName), (res) => {
        field.value = res.value;
      });
    }

    /**
     * Build picker element on GET call response and replace current values.
     *
     *     this.preparePicker(form, field, pickerName, includeValues);
     *
     * @param {HTMLElement} form
     * @param {HTMLElement} field
     * @param {String} pickerName
     * @param {Object} includeValues
     * @param {Object} [fields]
     * @param {Boolean} [isMultiple]
     * @return {void}
     */
    preparePicker(form, field, pickerName, includeValues, fields, isMultiple) {
      const self = this;
      // Reload on change of each element from the map!
      const data = {};

      if (includeValues) {
        data.input = ((map) => {
          Object.keys(map).forEach((key) => map[key] = self.getById(map[key]).value);
          return map;
        })(new Extend({}, includeValues).merge());
      }

      const defaultValue = field.getAttribute('data-picker-default-value');
      $.get(self.getPickerPathByName(pickerName), data, (res) => {
        var newField = field.newField;
        if (!newField) {
          newField = self.createPicker(field, isMultiple);
        }

        newField.innerHTML = '';

        for (var k in res.values || {}) {
          if (!res.values.hasOwnProperty(k)) {
            continue;
          }
          var $option = self.createPickerOption(k, res.values[k], defaultValue);
          newField.appendChild($option);
        }

        $(newField).trigger('chosen:updated');

        // For some reason addEventListener for change event doesn't work..
        // This is small workaround.
        newField.onchange = newField.onchange || function(evt) {
          const selectedOption = evt.target.options[evt.target.selectedIndex];
          if (this.value === 'add' && selectedOption.dataset.url) {
            window.location = selectedOption.dataset.url;
            return;
          }
          Object.keys(fields).forEach(function (key) {
            var picker = self.getById(key);
            var options = fields[key].options;
            var isDependOn = options.dependant_on && options.dependant_on.some(function (d) {
              return d === field.id;
            });
            if (isDependOn) {
              self.pickerVisibility(
                options.dependant_on,
                picker,
                form,
                options,
                fields
              );
            }
          });
          field.value = self.serializeSelectedOptions(newField.selectedOptions);
          var event = document.createEvent('Event');
          event.initEvent("change", true, false);
          field.dispatchEvent(event);
        };

        if (!field.newField) {
          field.parentElement.insertBefore(newField, field);
          field.newField = newField;
        }

        newField.selectedIndex = newField.selectedIndex || 0;
        // On HTML Select if value is set by JS,
        // change event won't be triggered,
        // so we need to run in manually.
        var event = document.createEvent('Event');
        event.initEvent("change", true, false);
        newField.dispatchEvent(event);
      });
    }

    /**
     * Set picker visibility, if all dependant on fields are set, and create picker options.
     *
     *     this.pickerVisibility(array, field, callback);
     *
     * @param {Array} array
     * @param {HTMLElement} field
     * @param {HTMLElement} form
     * @param {Object} options
     * @param {Object} fields
     * @return {void}
     */
    pickerVisibility(array, field, form, options, fields) {
      const self = this;
      var values = [];
      array.forEach(function (id) {
        var element = self.getById(id);
        values.push(self.hasValue(element));
      });

      var parentVisibility = values.every(function (v) {
        return !!v;
      });
      //this.setParentElementVisibility(field, parentVisibility);

      if (parentVisibility) {
        this.preparePicker(form, field, options.picker_name, options.include_values, fields, options.is_multiple);
      }
    }

    /**
     * Build select picker element from field properties.
     *
     *     var picker = this.createPicker(field);
     *
     * @param {HTMLElement} field
     * @param {Boolean} [isMultiple]
     * @return {HTMLElement} Select picker.
     */
    createPicker(field, isMultiple) {
      var select = document.createElement('select');
      var newId = field.getAttribute('id') + '__select';
      var newName = field.getAttribute('name') + '__select';

      if (isMultiple) {
        newName += '[]';
      }

      select.setAttribute('id', newId);
      select.setAttribute('name', newName);

      if (isMultiple) {
        select.setAttribute('multiple', 'multiple');
        select.setAttribute('size', '8');
      }

      select.classList.add('form-control', 'chosen-image-select');

      return select;
    }

    /**
     * Build option for select picker element.
     *
     *     var option = this.createPickerOption(value, text);
     *
     * @param {String} [value]
     * @param {String} [text]
     * @param {*} [defaultValue]
     * @return {HTMLElement} Select picker option.
     */
    createPickerOption(value, text, defaultValue) {
      var option = document.createElement('option');
      option.setAttribute('value', value);
      option.textContent = text;
      if (value === defaultValue) {
        option.setAttribute('selected', 'selected');
      }
      return option;
    }

    /**
     * Build a comma-separated value from selectedOptions
     *
     * @param {HTMLCollection} selectedOptions
     * @return {String} CSV
     */
    serializeSelectedOptions(selectedOptions) {
      var output = [];
      for (var i = 0; i < selectedOptions.length; ++i) {
        output.push(selectedOptions[i].value)
      }
      return output.join(',');
    }

    /**
     * Builds picker path to get picker values from. It combines JS and Twig.
     *
     * @param {String} pickerName
     * @return {String} Returns path to get picker values from
     */
    getPickerPathByName(pickerName) {
      const { baseUrl } = this.magicPickerDiv.dataset;
      return baseUrl.split('_pickerName_').join(pickerName);
    }

    /**
     * Get element by id.
     *
     *     var element = this.getById('id');
     *     // Returns DOM element by it's ID
     *
     * NOTE: Do not use querySelector because ID's contains semicolons which makes selectors invalid.
     *
     * @param {String} id
     * @return {HTMLElement|null} Returns element by id.
     */
    getById(id) {
      return document.getElementById(id);
    }
}
